import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { LngLatBounds } from "maplibre-gl";

import type { ApplicationState } from ".";

export const serializeBounds = (bounds: LngLatBounds) => bounds.toArray().join("|");

const sliceName = "mapSlice";
export interface MapExtentState {
	viewBounds?: string;
	zoom: number;
}

const initialState: MapExtentState = {
	viewBounds: undefined,
	zoom: 16,
};

const slice = createSlice({
	name: sliceName,
	initialState,
	reducers: {
		setViewBounds: (state, { payload }: PayloadAction<string>) => {
			state.viewBounds = payload;
		},
		setZoom: (state, { payload}: PayloadAction<number>) => {
			state.zoom = payload;
		}
	},
});

// ----------------
// exports
export const selectViewBounds = (state: ApplicationState) => state.mapExtentState.viewBounds;
export const selectZoom = (state: ApplicationState) => state.mapExtentState.zoom;
export const actions = {
	...slice.actions,
};
export const reducer = slice.reducer;
